(ns common.schema.entities.risk-holding.core
  "Common entity-type definition of the holding risk. It was an entry in
   `common.schema.entity-types`. The backend registry needs it, so that the
   dedicated index builds the holding risk documents with the calculated fields."
  (:require
   [common.schema.entities.risk-holding.schema :as risk-holding]
   [common.schema.entities.risk-holding.permissions :as permissions]))

(def entity-type-definition
  {:entity-type                  :entity.type/risk-holding
   :schema                       risk-holding/schema
   :name                         {:en "Holding risk"}
   :plural                       {:en "Holding risks"}
   :icon                         :fa-exclamation-triangle
   :read-permissions-check-fn    permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
